// tslint:disable
/**
 * TC API
 * TestCollab is a test management tool that helps development teams carry out testing effectively and avoid failures. # Introduction This is an API documentation for TestCollab 2.   # Authentication TestCollab supports two forms of authentication:   - An <b>API token</b> is required to make API calls. The token can be generated from user's profile; to obtain it login to your TestCollab account and go to ['My Profile Settings'](https://testcollab.io/my_profile) and switch to API Token tab. Click on \"Generate new API token\", Once the token is generated it can be sent as a query parameter for the API calls made - https://api.testcollab.io/projects?token=<generated-API-token>    - <b>Bearer authentication</b> (also called token authentication) is an HTTP authentication scheme that involves security tokens called bearer tokens. You can generate bearer auth token using [Login](#operation/login) API.     Send this token as the Authorization header while making requests to protected resources:     `Authorization: Bearer <token>`    For making API calls, we recommend using the <b>API token</b> generated from user profile page as it won't affect the on-going user session and will be available until it is revoked by the user who generated it.      # Error Handling Error responses   - `Not Found` - Error is sent when requested resource is not available.   - `Unauthorized - invalid token` - Error is sent when API token sent with the request is invalid or revoked. Error contains status code 401        - `Forbidden` - Error is sent when logged in user is not part of the company, project or his role does not allow to complete given action. Response consist of 403 status code and more information is given in error message.
 *
 * OpenAPI spec version: 2.3.1
 * Contact: support@testcollab.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists } from "../runtime";
import {
  ActivityAuditInfo,
  ActivityAuditInfoFromJSON,
  ActivityAuditInfoToJSON,
  ProjectMini,
  ProjectMiniFromJSON,
  ProjectMiniToJSON,
  User,
  UserFromJSON,
  UserToJSON,
} from "./";

/**
 *
 * @export
 * @interface Activity
 */
export interface Activity {
  /**
   * Type of entity
   * @type {string}
   * @memberof Activity
   */
  entity: string;
  /**
   * Entity ID
   * @type {number}
   * @memberof Activity
   */
  entityId: number;
  /**
   * Entity show/display field
   * @type {string}
   * @memberof Activity
   */
  entityTitle: string;
  /**
   * Test case title
   * @type {string}
   * @memberof Activity
   */
  testCaseTitle?: string;
  /**
   * Test plan title
   * @type {string}
   * @memberof Activity
   */
  testPlanTitle?: string;
  /**
   *
   * @type {ProjectMini}
   * @memberof Activity
   */
  project?: ProjectMini;
  /**
   * Activity Type
   * @type {string}
   * @memberof Activity
   */
  activityType: ActivityActivityTypeEnum;
  /**
   *
   * @type {User}
   * @memberof Activity
   */
  user: User;
  /**
   *
   * @type {ActivityAuditInfo}
   * @memberof Activity
   */
  auditInfo?: ActivityAuditInfo;
  /**
   * Time when the activity was performed
   * @type {string}
   * @memberof Activity
   */
  createdAt?: string;
  /**
   * Time when the activity was performed
   * @type {string}
   * @memberof Activity
   */
  updatedAt?: string;
}

export function ActivityFromJSON(json: any): Activity {
  return {
    entity: json["entity"],
    entityId: json["entity_id"],
    entityTitle: json["entity_title"],
    testCaseTitle: !exists(json, "test_case_title")
      ? undefined
      : json["test_case_title"],
    testPlanTitle: !exists(json, "test_plan_title")
      ? undefined
      : json["test_plan_title"],
    project: !exists(json, "project")
      ? undefined
      : ProjectMiniFromJSON(json["project"]),
    activityType: json["activity_type"],
    user: UserFromJSON(json["user"]),
    auditInfo: !exists(json, "audit_info")
      ? undefined
      : ActivityAuditInfoFromJSON(json["audit_info"]),
    createdAt: !exists(json, "created_at") ? undefined : json["created_at"],
    updatedAt: !exists(json, "updated_at") ? undefined : json["updated_at"],
  };
}

export function ActivityToJSON(value?: Activity): any {
  if (value === undefined) {
    return undefined;
  }
  return {
    entity: value.entity,
    entity_id: value.entityId,
    entity_title: value.entityTitle,
    test_case_title: value.testCaseTitle,
    test_plan_title: value.testPlanTitle,
    project: ProjectMiniToJSON(value.project),
    activity_type: value.activityType,
    user: UserToJSON(value.user),
    audit_info: ActivityAuditInfoToJSON(value.auditInfo),
    created_at: value.createdAt,
    updated_at: value.updatedAt,
  };
}

/**
 * @export
 * @enum {string}
 */
export enum ActivityActivityTypeEnum {
  Add = "add",
  Edit = "edit",
  Delete = "delete",
  Publish = "publish",
  Run = "run",
  StatusChange = "status_change",
  TestcaseStatusChange = "testcase_status_change",
  Archive = "archive",
  Reopen = "reopen",
  FinishedRun = "finished_run",
  AssigneeChange = "assignee_change",
  Comment = "comment",
  ReleaseVerdictChange = "release_verdict_change",
  Link = "link",
}
